import React, { Component } from 'react';
import NavBlockTampa from './NavBlockTampa';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import { dp, createFolderTree } from '../../../utils/shared.js';
import _ from 'lodash';

class NavTampa extends Component {
  constructor(props) {
    super(props);
    this._menuModules = _.filter(this.props.content.dm_active, { module_contents: { in_navigation: true } });
    
    this._background = null;
    this._arrow = null;
    this._logo = null;

    this.initializeAssets();

    this.state = {
      initializedRefs: false
    }
    this.navRefs = [];
  }

  handleNav = (route) => {
    this.props.navRoute(route.navLocation, route.module);
  }
  
  componentDidMount() {
    this.props.toggleShowNav(false);
  }

  componentWillUnmount() {
    for (let a = 0; a < this.navRefs.length; a++) {
      if (this.navRefs[a].el) {
        this.navRefs[a].el.removeEventListener("tap", () => this.handleNav(this.navRefs[a].data));
      }
    }
    this.props.toggleShowNav(true);
  }

  initializeNavRefs = () => {
    if (this.state.initializedRefs === false) {
      for (let a = 0; a < this.navRefs.length; a++) {
        this.navRefs[a].el.addEventListener("tap", () => this.handleNav(this.navRefs[a].data));
      }
      this.setState({
        initializedRefs: true
      })
    }
  }

  initializeAssets = () => {
    let menuFolder = this.props.content.story_categories.find(folder => {
      let folderType = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      if (folderType !== null) {
        return folder.parent_category === Number(this.props.content.settings.selected_root_folder) && folderType === "menu"
      }

      return false;
    });
    let backgroundImage = _.get(menuFolder.contents, 'images[0]', null);
    let logoImage = _.get(menuFolder.contents, 'images[1]', null);
    let arrowImage = _.get(menuFolder.contents, 'images[2]', null);    

    let defaultBackground = { path:'/img/miami/general/', file_name:"default_single_screen.jpg" }
    if (this.props.screensNumber === 2) {
      defaultBackground.file_name = 'default_double_screen.jpg';
    }

    this._background = dp(this.props.screen, backgroundImage, defaultBackground);
    this._arrow = dp(this.props.screen, arrowImage);
    this._logo = dp(this.props.screen, logoImage);
  }

  prepareMenuNavigation() {
    let location = [];
    let menuFolder = this.props.content.story_categories.find(folder => {
      let folderType = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      if (folderType !== null) {
        return folder.parent_category === Number(this.props.content.settings.selected_root_folder) && folderType === "menu"
      }
      return false;
    });

    let menu = createFolderTree(this.props.content.story_categories, this.props.content.folder_modules, menuFolder, this.props.content.stories, this.props.content.dm_active, null, null);

    return (
      menu.map((row, i) => {
        let type = _.get(row, 'contents.custom_fields.folder_type.val.value', null);
        
        switch(type) {
          case 'donor_lists_wrapper':
            location[i] = "/tampa/donor_lists";
          break;
          case 'donor_stories':
            location[i] = "/tampa/stories";
          break;
          case 'timeline':
            location[i] = "/tampa/timeline";
          break;
          case 'search':
            location[i] = "/tampa/search";
          break;
          default:
          break;
        }

        let description = _.get(row.contents, 'custom_fields.menu_description.val', null);
        return (
          <div key={i}>
            <div ref={el => this.navRefs[i] = { el: el, data: { navLocation: location[i], module: row } }}>
              <NavBlockTampa
                title={row.name}
                description={description}
                screen={this.props.screen}
                containerWidth={this.props.screen.screenWidth / this.props.screensNumber}
                icon={dp(this.props.screen, _.get(row, 'contents.images[1]', null))}
                arrow={this._arrow}/>
            </div>
            <div style={{ height: '1.71673819742489270386vh' }}></div>
          </div>
        )
      })
    );
  }

  render() {
    return (
      <div style={{ height: this.props.screen.r9_16.height, textAlign: 'center', width: '100%', backgroundSize: "cover", backgroundImage: "url("+this._background+")" }}>
        <div style={{ height: '5vh' }}></div>
        <div style={{ width:this.props.screen.screenWidth / this.props.screensNumber }}>
          <img alt="Logo" src={this._logo} style={{ display: 'block', margin: 'auto', width: '39vh' }} />
          <div style={{ height: '4vh' }}></div>
          <div style={{ width: this.props.screen.screenWidth, height: '125vw', touchAction:"none" }}>
            <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
              options={{
                mouseWheel: true,
                scrollbars: false,
                scrollX: false,
                scrollY: true,
                probeType: 2,
                bounce: false,
                momentum: true,
                deceleration: 0.015,
                useTransition: true,
                disableTouch: false,
                disablePointer: false,
                disableMouse: false,
                tap: true
              }}
              onScrollStart={this.onScrollStart}
              onRefresh={this.initializeNavRefs}
            >
              <div style={{ width: this.props.screen.screenWidth / this.props.screensNumber }}>
                {this.prepareMenuNavigation()}
              </div>
            </ReactIScroll>
          </div>
        </div>
      </div>

    )
  }
}

export default NavTampa


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/NavTampa.jsx